import React, { useState, useEffect } from 'react';
import {
    PaymentElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';

const CheckoutForm = ({ plan, onSuccess, onError }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (!stripe || !elements) {
            return;
        }

        const element = elements.getElement(PaymentElement);
        if (!element) {
            return;
        }

        element.on('ready', () => {
            setIsReady(true);
        });

        element.on('loaderror', (event) => {
            setMessage(`Errore nel caricamento: ${event.error.message}`);
        });

        return () => {
            element.off('ready');
            element.off('loaderror');
        };
    }, [stripe, elements]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements || !isReady) {
            return;
        }

        setIsProcessing(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/payment-success`,
            },
        });

        if (error) {
            setMessage(error.message);
        }

        setIsProcessing(false);
    };

    if (!stripe || !elements) {
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <CircularProgress />
                <p>Caricamento del modulo di pagamento...</p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Completa Acquisto - {plan.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                    Totale: ${plan.price}
                </Typography>
            </Box>

            <PaymentElement />

            {message && (
                <Alert severity="error" style={{ marginTop: '10px' }}>{message}</Alert>
            )}

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={isProcessing || !isReady}
                sx={{ mt: 3 }}
            >
                {isProcessing ? 'Elaborazione...' : 'Paga ora'}
            </Button>
        </form>
    );
};

export default CheckoutForm; 